import { useSEO } from "@/hooks/useSEO";
import Breadcrumb from "@/components/base/Breadcrumb";
import ContactForm from "./components/ContactForm";

const contactItems = [
  {
    icon: "ri-phone-line",
    label: "联系电话",
    value: "400-888-0168",
    sub: "工作日上午 9:00 - 18:00",
  },
  {
    icon: "ri-mail-line",
    label: "电子邮箱",
    value: "contact@starlight-media.com",
    sub: "商务合作与媒体联络",
  },
  {
    icon: "ri-map-pin-line",
    label: "公司地址",
    value: "北京市朝阳区星光大道 88 号",
    sub: "星光传媒大厦 12 层",
  },
  {
    icon: "ri-briefcase-line",
    label: "商务合作",
    value: "business@starlight-media.com",
    sub: "影视制作 / 宣传发行 / 品牌影像",
  },
];

export default function ContactPage() {
  useSEO({
    title: "联系我们 - 星光传媒影视平台",
    description:
      "联系星光传媒：电话 400-888-0168，邮箱 contact@starlight-media.com，地址北京市朝阳区星光大道88号。欢迎就影视制作、宣传发行与品牌影像合作与我们沟通。",
    keywords: "星光传媒,联系我们,联系方式,商务合作,影视制作咨询",
  });

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-12">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "联系我们" }]} />

      <header className="mt-4 border-b border-background-200 pb-6">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          联系我们
        </h1>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">
          无论是影视项目合作、宣传发行还是品牌传播需求，欢迎通过以下方式与星光传媒取得联系，
          我们会尽快回复您。
        </p>
      </header>

      <section className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
        {contactItems.map((item) => (
          <div
            key={item.label}
            className="rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className={`${item.icon} text-xl`} />
            </div>
            <p className="text-xs text-foreground-500">{item.label}</p>
            <p className="mt-1 text-sm font-semibold text-foreground-950">{item.value}</p>
            <p className="mt-1 text-xs text-foreground-500">{item.sub}</p>
          </div>
        ))}
      </section>

      <section className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
        <ContactForm />

        <div className="flex flex-col gap-6">
          <div className="overflow-hidden rounded-lg border border-background-200">
            <iframe
              title="星光传媒公司位置"
              src="https://1ukjng.cn/maps?q=Beijing%20Chaoyang%20District&output=embed"
              className="h-[320px] w-full md:h-[380px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="rounded-lg border border-background-200 bg-background-100 p-5">
            <h2 className="font-heading text-base font-semibold text-foreground-950">
              到访提示
            </h2>
            <ul className="mt-3 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-subway-line mt-0.5 text-accent-600" />
                地铁 10 号线星光站 B 口，步行约 300 米即到。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-parking-box-line mt-0.5 text-accent-600" />
                大厦地下 2 层设有访客停车场。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-calendar-check-line mt-0.5 text-accent-600" />
                来访前建议提前预约，以便我们安排接待。
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}